import { LoadingButton } from '@mui/lab';
import { Box, Paper, styled, Typography, Modal, Button } from '@mui/material';
import Fade from '@mui/material/Fade';
import { useSelector } from 'react-redux';
import {
  planError,
  planMessage,
  planStatus,
} from '../features/planes/planesSlice';
import CustomAlert from './CustomAlert';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  boxShadow: 24,
  padding: '2rem 2rem 2rem 2rem',
};

const ModalWrapper = styled(Paper)(({ theme }) => ({
  border: '2px solid',
  borderColor: theme.palette.primary.main,
  textAlign: 'center',
}));

interface PlanProps {
  openModal: boolean;
  setOpenModal: (v: boolean) => void;
  cuotas: number;
  handlePlanConfirmation: () => void;
  handlePlanFinalization: () => void;
  isLoading: boolean;
}

export default function PlanModal(props: PlanProps) {
  const {
    openModal,
    setOpenModal,
    cuotas,
    handlePlanConfirmation,
    handlePlanFinalization,
    isLoading,
  } = props;

  const message = useSelector(planMessage);
  const status = useSelector(planStatus);
  const error = useSelector(planError);

  const handleModalToggle = () => setOpenModal(!openModal);

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={() => setOpenModal(!openModal)}
        closeAfterTransition
      >
        <Fade in={openModal}>
          <ModalWrapper sx={style}>
            <Box my={2}>
              <Typography>
                <strong>Plan: {cuotas} Cuotas </strong>
              </Typography>
              {
                status !== 'success' && status !== 'error'
                  ? <>
                      <Typography variant="body2" my={2}>
                        ¿Desea confirmar la solicitud de plan de pagos seleccionado?
                      </Typography>
                      <Typography variant="body2">
                        Recuerde que los planes solamente podrán ser anulados por
                        ventanilla en el Palacio Municipal.
                      </Typography>
                    </>
                  : null
              }
            </Box>

            <CustomAlert status={status} message={message} errorMessage={error} style={{ marginTop: '1rem' }}/>

            {
              status === 'success' || status === 'error'
                ? <Button
                    variant="contained"
                    onClick={ handlePlanFinalization }
                    sx={{ marginTop: '1rem', color: 'white', width: '40%' }}
                    disabled={ isLoading }
                  >
                    Aceptar
                  </Button>
                : <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
                    <LoadingButton
                      loading={ isLoading || status !== 'idle' }
                      variant="contained"
                      onClick={ handlePlanConfirmation }
                      sx={{ width: '40%' }}
                    >
                      Confirmar
                    </LoadingButton>
                    <Button
                      variant="outlined"
                      sx={{ width: '40%' }}
                      onClick={ handleModalToggle }
                      disabled={ isLoading }
                    >
                      Cancelar
                    </Button>
                  </Box>
            }
          </ModalWrapper>
        </Fade>
      </Modal>
    </div>
  );
}
